module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "image-cropper"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imageSelected),
      expression: "imageSelected"
    }],
    staticClass: "row",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "cropit-preview center-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.acw($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cw($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat "
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "btn btn-default btn-file col-md-3"
  }, [_vm._v("\n                    Browse "), _c('input', {
    staticClass: "cropit-image-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileSelected
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "cropit-image-zoom-input",
    attrs: {
      "type": "range"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26ffd948", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ffd948"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/formimage/formimage.scp.html
// module id = 524
// module chunks = 0